<script setup lang="ts">
import { BaseIconMarketplaceLogo } from "#components";
import { version } from "../../package.json";

definePageMeta({
  layout: "simple",
});

const { maintenanceURI } = useRuntimeConfig().public;

onMounted(() => {
  refreshURL("https://gfal.market");
  refreshURL("https://gfal.market/#/auth");
});
</script>

<template>
  <div class="min-h-screen flex flex-col items-center overflow-hidden">
    <header
      class="w-screen h-36 lg:h-52 flex justify-center items-center gap-4 lg:my-5 px-6 border-b border-secondary-500">
      <NuxtLinkLocale to="/">
        <BaseIconMarketplaceLogo
          :alt="$t('main.imageAltTexts.GFALLogo')"
          class="" />
      </NuxtLinkLocale>
    </header>
    <div
      class="relative isolate bg-secondary-900 max-w-2xl flex flex-col justify-center items-center gap-4 my-4">
      <NuxtIcon
        name="mdi:hammer-wrench"
        class="mt-20 mb-10 w-30 h-30 text-neutral-300" />
      <h2
        class="mx-auto max-w-2xl text-[42px] font-bold text-neutral-200 text-center">
        {{ $t("main.underMaintenance.underMaintenance") }}
      </h2>
      <div class="flex flex-col justify-center items-center gap-4">
        <p class="max-w-lg mx-auto px-3 text-center text-base text-neutral-300">
          {{ $t("main.underMaintenance.maintenanceMessage") }}
        </p>
        <p class="max-w-lg mx-auto px-3 text-center text-base text-neutral-300">
          {{ $t("main.underMaintenance.maintenanceApology") }}
        </p>
        <a
          :href="maintenanceURI"
          target="_blank"
          class="text-neutral-300 hover:text-primary-500 underline"
          >{{ $t("main.underMaintenance.moreInfo") }}</a
        >
      </div>
    </div>
    <footer class="w-screen bg-neutral-800 mt-auto">
      <div
        class="mx-auto px-6 py-5 flex flex-col-reverse xl:flex-row items-center lg:px-8 gap-4">
        <div class="md:mt-0 flex-1">
          <p class="text-xs leading-5 text-neutral-300 text-center">
            {{
              $t("main.underMaintenance.copyrightNotice", {
                year: new Date().getFullYear(),
                version: version.split("_")[0],
              })
            }}
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>
